/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import questionsData from "./questionnaire.json";
import LeadContactForm from "./LeadContactForm";
import Services from "./Services";
import Income from "./Income";
import Questionnaire from "./Questionnaire";
import './QuestionnaireForm.scss'


const QuestionnaireForm = ({proxyUrl, data_source, redirectUrl}) => {
  const storageAnswers = localStorage.getItem('assesment')
  const storageStep = localStorage.getItem('walthroughStep')
  const [questions, setQuestions] = useState(storageAnswers ? JSON.parse(storageAnswers) : questionsData);
  const totalSteps = questions.length + 5;
  const [step, setStep] = useState(storageStep ? Number(storageStep) : 1);
  const [currentQuestion, setCurrentQuestion] = useState(storageStep ? Number(storageStep) : 1);
  const [answers, setAnswers] = useState();
  const [serviceOptions, setServicesOptions] = useState([]);
  const [income, setIncome] = useState([]);
  const [user, setUser] = useState(null);



    function StepDots({ totalSteps = 6, currentStep = 1 }) {
  return (
    <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
      {[...Array(totalSteps)].map((_, idx) => {
        const isActive = idx + 1 === currentStep;

        return (
          <div
            key={idx}
            className={`rounded-pill`}
            style={{
              width: isActive ? "10px" : "7px",
              height: "7px",
              backgroundColor: isActive ? "#4F46E5" : "#cbd5e1", 
              transition: "all 0.3s ease",
            }}
          />
        );
      })}
    </div>
  );
}



  useEffect(() => {
    localStorage.setItem('assesment',JSON.stringify(questions))
    localStorage.setItem('walthroughStep', Number(currentQuestion))
  }, [questions,currentQuestion])

  const handleNext = (byTwo = false) => {
    setStep((prev) => (prev < totalSteps ? prev + (byTwo ? 2 : 1) : prev));
    if (currentQuestion < questions.length) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handleAnswer = (question, answer, type) => {
    const questionID = question?.id;
    if (type === "checkbox") {
      if (question?.selectedAnswers?.includes(answer?.toString())) {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: q?.selectedAnswers?.filter(
                  (a) => a !== answer?.toString()
                ),
              };
            }
            return q;
          })
        );
      } else {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: [
                  ...(q?.selectedAnswers || []),
                  answer?.toString(),
                ],
              };
            }
            return q;
          })
        );
      }
    } else if (type === "radio") {
      if (question?.selectedAnswers?.includes(answer?.toString())) {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: q?.selectedAnswers?.filter(
                  (a) => a !== answer?.toString()
                ),
              };
            }
            return q;
          })
        );
      } else {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: [answer?.toString()],
              };
            }
            return q;
          })
        );
      }
    }
  };

  const progressPercent = (step / totalSteps) * 100;

  React.useEffect(() => {
    const current = questions[currentQuestion - 1];
    if (!current) return;
    if (current.checkMany) {
      setAnswers([]);
    } else {
      setAnswers("");
    }
  }, [currentQuestion]);

  return (
    <div  style={{ height: "100vh" }}>
      {step !== questions?.length + 3 && (
        <div className="container py-4 px-4">
           <div className="text-center">
            Step {step} of {16}
          </div>
          <StepDots totalSteps={16} currentStep={step} />
        </div>
      )}

      {currentQuestion && questions?.length >= step ? (
        <Questionnaire
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
          questions={questions}
          step={step}
          setStep={setStep}
          answers={answers}
          setAnswers={setAnswers}
          handleNext={handleNext}
          handleAnswer={handleAnswer}
          setQuestions={setQuestions}
        />
      ) : null}
      {step === questions?.length + 1 && (
        <Services
          serviceOptions={serviceOptions}
          setServicesOptions={setServicesOptions}
          handleNext={handleNext}
          step={step}
          setStep={setStep}
        />
      )}
      {step === questions?.length + 2 && (
        <Income
          setIncome={setIncome}
          handleNext={handleNext}
          step={step}
          setStep={setStep}
          income={income}
        />
      )}
      {step === questions?.length + 3 && (
        <LeadContactForm
          handleNext={handleNext}
          serviceOptions={serviceOptions}
          income={income}
          setUser={setUser}
          questions={questions}
          proxyUrl={proxyUrl}
          data_source={data_source}
          redirectUrl={redirectUrl}
        />
      )}
    </div>
  );
};

export default QuestionnaireForm;
